import { firebaseFunctions, firestore } from '../../firebase/firebase';
import { FirebaseCallableFunctions, FirestoreCollection } from '../../firebase/firebase.models';
import { useSequentialId } from '../useSequentialId.hook';

export const onLogOfferSubmitConfirm = (offerId: string): void => {
  const { generateSequentialId } = useSequentialId();

  generateSequentialId().then((newCounter) => {
    firestore
      .collection(FirestoreCollection.EVENTS)
      .doc(newCounter.toString())
      .set({
        method: 'onLogOfferSubmitConfirm',
        details: 'User submitted an offer',
        offerId: offerId,
        date: new Date(),
      })
      .then(() => {
        const notifyAdminOnContractSigned = firebaseFunctions.httpsCallable(
          FirebaseCallableFunctions.NOTIFY_ADMIN_ON_CONTRACT_SIGNED
        );
        notifyAdminOnContractSigned({ offerId: offerId });
      })
      .catch((error) => {
        console.log(error);
      });
  });
};
